import { gql } from "@apollo/client";

export const CREATE_LOCATION_MUTATION = gql`
  mutation CreateLocation($input: CreateLocationInput!) {
    createLocation(input: $input) {
      id
      locationName
      description
      locationType
      locationTypeName
      address
      city
      state
      zipcode
      country
      coordinates
      parentId
    }
  }
`;

// Update Location Mutation

export const UPDATE_LOCATION_MUTATION = gql`
  mutation UpdateLocation($input: UpdateLocationInput!) {
    updateLocation(input: $input) {
      id
      locationName
      description
      locationType
      locationTypeName
      address
      city
      state
      zipcode
      country
      coordinates
      parentId
      fileIds
      standards
    }
  }
`;

export const NEST_LOCATION_UNDER_PARENT_MUTATION = gql`
  mutation NestLocationUnderParent($input: NestLocationUnderParentInput!) {
    nestLocationUnderParent(input: $input) {
      id
      locationName
      locationType
      locationTypeName
      parentId
    }
  }
`;

export const UPDATE_LOCATION_SCENE_DATA_MUTATION = gql`
  mutation UpdateLocationSceneData($input: UpdateLocationSceneDataInput!) {
    updateLocationSceneData(input: $input) {
      id
      updatedAt
      metadata
    }
  }
`;

export const SAVE_BUILDING_SCENE_CHANGES_MUTATION = gql`
  mutation SaveBuildingSceneChanges($input: SaveBuildingSceneChangesInput!) {
    saveBuildingSceneChanges(input: $input) {
      buildingLocationId
      updatedAssetIds
      upsertedConnectionIds
      deletedConnectionIds
    }
  }
`;

// Delete Location Mutation

export const DELETE_LOCATION_MUTATION = gql`
  mutation DeleteLocation($input: DeleteLocationInput!) {
    deleteLocation(input: $input)
  }
`;

// Update Asset Mutation

export const FACILITY_ONBOARD_MUTATION = gql`
  mutation FacilityOnboard($input: FacilityOnboardInput!) {
    facilityOnboard(input: $input) {
      success
      message
      locationId
      facilityGraph {
        siteName
        siteAddress
        organization
        totalBuildings
        coordinates { latitude longitude }
        discoveryDate
        source
        mapsLink
        buildings {
          name
          buildingType
          floors
          squareFootage
          yearBuilt
          description
          isPrimary
          form
          facade
          color
          opacity
          coordinates { latitude longitude }
          polygon
          assets { name uid type floorIndex description confidence position { dx dy dz } }
          connections { fromIdx toIdx type color waypoints { dx dy dz } }

        }
      }
    }
  }
`;

// Facility Session Query

// Save edited facility graph

export const SAVE_FACILITY_GRAPH_MUTATION = gql`
  mutation SaveFacilityGraph($input: SaveFacilityGraphInput!) {
    saveFacilityGraph(input: $input) {
      success
      message
      locationId
      facilityGraph {
        siteName
        siteAddress
        organization
        totalBuildings
        coordinates { latitude longitude }
        discoveryDate
        source
        mapsLink
        buildings {
          name
          buildingType
          floors
          squareFootage
          yearBuilt
          description
          isPrimary
          form
          facade
          color
          opacity
          coordinates { latitude longitude }
          polygon
          assets { name uid type floorIndex description confidence position { dx dy dz } }
          connections { fromIdx toIdx type color waypoints { dx dy dz } }

        }
      }
    }
  }
`;

// Resolve Google Maps URL to coordinates
// Save facility structure — creates building/floor locations + asset records

export const SAVE_FACILITY_STRUCTURE_MUTATION = gql`
  mutation SaveFacilityStructure($input: SaveFacilityGraphInput!) {
    saveFacilityStructure(input: $input) {
      success
      message
      locationId
      buildingIds
      floorIds
      assetCount
    }
  }
`;

export const RESOLVE_GOOGLE_MAPS_URL = gql`
  query ResolveGoogleMapsUrl($url: String!) {
    resolveGoogleMapsUrl(url: $url) {
      name
      address
      city
      state
      country
      zipcode
      latitude
      longitude
      placeId
      types
    }
  }
`;

export const ADD_LOCATION_TIMELINE_EVENT_MUTATION = gql`
  mutation AddLocationTimelineEvent($input: AddLocationTimelineEventInput!) {
    addLocationTimelineEvent(input: $input) {
      id
      locationId
      type
      title
      notes
      createdAt
      updatedAt
      createdByUser {
        id
        firstName
        lastName
      }
    }
  }
`;

export const UPDATE_LOCATION_TIMELINE_EVENT_MUTATION = gql`
  mutation UpdateLocationTimelineEvent($input: UpdateLocationTimelineEventInput!) {
    updateLocationTimelineEvent(input: $input) {
      id
      locationId
      type
      title
      notes
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_LOCATION_TIMELINE_EVENT_MUTATION = gql`
  mutation DeleteLocationTimelineEvent($id: ID!) {
    deleteLocationTimelineEvent(id: $id)
  }
`;
